import { useState, useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { BiMenu, BiX } from "react-icons/bi";
import AuthContext from "../context/auth/AuthContext";
import img from "../assets/header_background.jpg";

function Header() {
  const { usuario, cerrarSesion } = useContext(AuthContext);
  const [show, setShow] = useState(false);

  const toggle = () => setShow(!show);

  return (
    <HeaderContainer>
      <Link to="/">
        <Logo>Green & Fit</Logo>
      </Link>
      {usuario && (
        <Nav>
          <Hamburger onClick={toggle}>{show ? <BiX /> : <BiMenu />}</Hamburger>
          {usuario && usuario.administrador ? (
            <Enlaces onClick={toggle} show={show}>
              <Link to="/">Inicio</Link>
              <Link to="/platos">Platos</Link>
              <Link to="/menus">Menús</Link>
              <CerrarBtn type="button" onClick={cerrarSesion}>
                Salir
              </CerrarBtn>
            </Enlaces>
          ) : (
            <Enlaces onClick={toggle} show={show}>
              <span></span>
              <span>Bienvenido, {usuario.nombre}</span>
              <CerrarBtn type="button" onClick={cerrarSesion}>
                Salir
              </CerrarBtn>
            </Enlaces>
          )}
        </Nav>
      )}
    </HeaderContainer>
  );
}

const HeaderContainer = styled.header`
  width: 100%;
  height: 20vh;
  padding: 1rem;
  top: 0;
  position: sticky;
  z-index: 999;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0.6)
    ),
    url(${img});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  a {
    text-decoration: none;
  }
`;

const Nav = styled.nav`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const Enlaces = styled.div`
  width: 90%;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  span {
    font-weight: 500;
  }
  a {
    text-decoration: none;
    text-transform: uppercase;
    color: #262626;
    font-weight: 400;
    transition: all 0.5s ease;
    &:hover {
      color: #0d0d0d;
      padding: 0.2rem;
      font-weight: 500;
      border: 2px solid #0d0d0d;
      border-radius: 5px;
    }
  }
  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 80vh;
    position: absolute;
    top: 110px;
    left: ${({ show }) => (show ? "0" : "-100%")};
    a {
      color: #ccc;
      &:hover {
        color: #fff;
        border-bottom: 2px solid #fff;
      }
    }
    background-color: rgba(0, 0, 0, 1);
    transition: all 0.5s ease;
  }
`;

const CerrarBtn = styled.button`
  width: 5rem;
  height: 2rem;
  border-radius: 5px;
  border: none;
  outline: 0;
  cursor: pointer;
  transition: all 0.5s ease;
  color: #fff;
  text-transform: uppercase;
  background: #a61f12;
  &:hover {
    background: #d92a1a;
  }
`;

const Logo = styled.h1`
  font-size: 1.8rem;
  font-weight: 500;
  margin-top: 0;
  text-align: center;
  color: #034001;
  text-shadow: 4px 4px 4px #055902;
`;

const Hamburger = styled.div`
  display: none;
  @media (max-width: 1000px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-50%, 20%);
    font-size: 3rem;
    color: #262626;
    cursor: pointer;
  }
`;

export default Header;
